export default __webpack_public_path__ + "4e16ae78e369a97918c55363617e7848.png";